import React from 'react'
import { connect } from 'react-redux'
import SLBarrioSitesInfoTable from './SLBarrioSitesInfoTable'
import SLBarriosInfoTable from './SLBarriosInfoTable'

// this component was created to avoid rerender
function BarriosInfo(props) {
  return props.activeBarrios ? (
    <SLBarrioSitesInfoTable />
  ) : (
    <SLBarriosInfoTable />
  )
}

export default connect(state => ({
  activeBarrios: state.getIn(['seaLice', 'activeBarrios']),
}))(BarriosInfo)
